import { post , get, getBody, postFile } from '../axiosconfig'
import qs from 'qs'
export default {
  // 新增工单
  addAWorkOrder(params,headers) {
    return postFile('/zsc/web/console/ticket/create', params,headers)
  },
  //工单问题分类
  obtainClassification(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/ticket/category/list', params)
  },
  //工单概况
  getAnOverview(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/ticket/dashboard', params)
  },
    //工单列表
  getList(params) {
    return post('/zsc/web/console/ticket/list', params)
  },
  //工单详情
  getDetails(params) {
    return post('/zsc/web/console/ticket/detail', params)
  },
  // 工单回复
  getReplay(params) {
    return post('/zsc/web/console/ticket/replay', params)
  },
  //工单评分
  workOrderRating(params) {
    return post('/zsc/web/console/ticket/grade', params)
  },
}



// WEBPACK FOOTER //
// ./src/api/public/workOrder_api.js